import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("recoverymatch_admin_token");
    if (!token) {
      setAdmin(null);
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/admin/auth/me");
      setAdmin(res.data);
      localStorage.setItem("recoverymatch_admin_user", JSON.stringify(res.data));
    } catch (e) {
      if (e.response?.status === 401) {
        localStorage.removeItem("recoverymatch_admin_token");
        localStorage.removeItem("recoverymatch_admin_user");
        setAdmin(null);
      } else {
        // network blip: fall back to cached identity (backend remains the boundary)
        try {
          setAdmin(JSON.parse(localStorage.getItem("recoverymatch_admin_user")));
        } catch { setAdmin(null); }
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const hasPerm = useCallback(
    (perm) => !perm || admin?.is_super_admin || (admin?.permissions || []).includes(perm),
    [admin]
  );

  return (
    <AdminAuthContext.Provider value={{ admin, loading, hasPerm, refresh }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
};
